module.exports = __webpack_public_path__ + "static/media/400106_02.979d77b4.png";